<template>
  <b-container fluid>
    <backlink />
    <h1>Contrôles et réparations</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="status" slot-scope="{data}">
        <b-badge variant="primary">{{ data.value }}</b-badge>
      </template>
      <template slot="group_slug" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge v-if="data.value == 'OC'" variant="outillage" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else-if="data.value == 'SL'" variant="service_et_logistique" class="circle float-left" v-b-tooltip.hover
                   :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else-if="data.value == 'IM'" variant="instruments" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('instruments').text">
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
      <template slot="actions" slot-scope="{ data }">
        <b-button v-if="data.item.type_slug == 'calibration'" @click="downloadCertificate(data.item)"
          @click.prevent="external_maintenance_id = data.item.id" v-b-tooltip.hover
          title="Télécharger le certificat obligatoire"
          :variant="data.item.control_certificate ? 'primary' : 'outline-secondary'"
          :disabled="!data.item.control_certificate">
          <i class="far fa-download"></i>
        </b-button>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "ExternalMaintenanceList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function() {
      return {
        provider_id_options: this.$store.getters["company/getByTypeCode"]([
          "FRNI",
          "PRST"
        ]).selectOptions("id", "name"),
        type_slug_options: this.$store.getters[
        config.storeNamespace + "/getTypes"
        ],
        agency_options: this.$store.getters["agency/getAll"].selectOptions("internal_number", ["internal_number", " - ", "name"]),
        group_slug_options: this.$store.getters["renting_preparation/getGroups"],
        return_mode_options: this.$store.getters["product/getReturnModes"],
        provider_options: this.$store.getters["company/getByTypeCode"]([
          "FRNI",
          "PRST"
        ]).selectOptions("id", "name"),
        reference_options: this.$store.getters["reference/getAll"].selectOptions("id", [
          "product.name",
          " - ",
          "internal_code",
        ]),
        from_mcs_options: [
          { value: null, text: "Toutes" },
          { value: '1', text: "Import MCS" },
          { value: '0', text: "Catalogue ESM" },
        ],
      };
    }
  },
  created() {
    this.$store.dispatch("reference/getAllForSelect");
    this.$store.dispatch("company/getAllForSelect");
    this.$store.dispatch("agency/getAllForSelect");
  },
  methods: {
    /**
     * Fournit les données à AdminTableSync (pagination côté serveur). Appelée à
     * chaque rafraîchissement de la liste.
     */
    itemsProvider(ctx) {
      var self = this;
      var f = ctx.extended_filters_model || {};
      var day = (d) => (d ? self.$moment(d).format("YYYY-MM-DD") : null);
      var startDate = f.start_date || {};
      var endDate = f.end_date || {};
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "externalmaintenance", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              agency: f.agency,
              group_slug: f.group_slug,
              type_slug: f.type_slug,
              provider: f.provider,
              reference: f.reference,
              return_mode: f.return_mode,
              start_date_from: day(startDate.start),
              start_date_to: day(startDate.end),
              end_date_from: day(endDate.start),
              end_date_to: day(endDate.end),
              from_mcs: f.from_mcs,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.externalMaintenances || [],
            });
          })
          .catch(() => {
            self.$toastr.error("Le chargement de la liste a échoué");
          });
      });
    },
    downloadCertificate(item){
      window.open(process.env.BACK_FILES_URL+item.control_certificate.file, '_blank');
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.btn {
  &.btn-primary-lighter {
    background-color: lighten($primary, 30%);
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExternalMaintenance/ExternalMaintenanceList.vue